import React from 'react';

const PendingQuotaModal = ({ show, onClose, pendingList, selectedUser, onApprove, onReject, formatDate }) => {
  if (!show) return null;
  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Solicitudes pendientes de {selectedUser?.full_name}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {pendingList.length === 0 ? (
              <p className="text-muted">No hay solicitudes pendientes.</p>
            ) : (
              <ul className="list-group">
                {pendingList.map((req) => (
                  <li key={req.payment_id} className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="col-8">
                      <strong>Documentos:</strong> {req.document_count} <br/>
                      <strong>Monto:</strong> S/ {req.total_amount} <br/>
                      <strong>Tipo:</strong> {req.payment_type} <br/>
                      <strong>Código:</strong> {req.confirmation_code} <br/>
                      <small className="text-muted">{formatDate(req.created_at)}</small>
                    </div>
                    <div className="col-4">
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => onApprove(req.payment_id)}
                      >Aprobar</button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => onReject(req.payment_id)}
                      >Rechazar</button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingQuotaModal;
